import React from "react";
import { injectIntl } from "react-intl";

export default injectIntl((props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
});
